var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mainContent bg-contain common-blue-contain"},[(_vm.showSystemPath)?_c('iframe',{attrs:{"id":"iframe","src":_vm.showSystemPath,"width":"100%","height":"100%","frameborder":"0","allow":"encrypted-media; microphone; fullscreen; autoplay; speaker; midi;"}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }